import { render, staticRenderFns } from "./GiftingAddressForm.vue?vue&type=template&id=1e12431f&"
import script from "./GiftingAddressForm.vue?vue&type=script&lang=js&"
export * from "./GiftingAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports